module.exports = __webpack_public_path__ + "img/9791164136452.1e0cd195.jpg";